module.exports = __webpack_public_path__ + "img/5.bfd12009.jpg";